// src/config/planConfig.js
export const PLAN_CONFIG = {
  profitable: {
    name: "Profitable Trader Plan",
    basePrice: 1999, // Change this one value to update the whole app
    usdPrice: 22,
    features: [
      "Account Dashboard (Full Analytics)",
      "News Event Bar (Impact Filters)",
      "Institutional Lot Calculator",
      "Win Rate & Equity Curves",
      "Psychology & Mindset Tracking",
      "Priority Data Sync"
    ]
  }
};